import React from 'react';
import classNames from 'classnames';
import styles from './Select.module.scss';

export interface FieldProps {
  choices: string[];
  choicesLabel?: string[];
  choicesDisabled?: boolean[];
  value?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  width?: string;
  height?: string;
  placeholder?: string;
  showPlaceholder?: boolean;
  placeholderValue?: string;
  className?: string;                                                  // Classe CSS personnalisée
}

export const Select = ({
  choices,
  choicesLabel,
  choicesDisabled,
  value,
  disabled,
  onChange,
  width = 'fit-content',
  height = '26px',
  placeholder = 'Sélectionnez une option',
  showPlaceholder = true,
  placeholderValue = '',
 className 
}: FieldProps) => {
  const labels = choicesLabel && choicesLabel.length === choices.length ? choicesLabel : choices;
  const disabledStates = choicesDisabled && choicesDisabled.length === choices.length ? choicesDisabled : choices.map(() => false);
  const normalizedValue = value != null ? String(value) : '';
  const isValid = choices.includes(normalizedValue);
  const safeValue = isValid ? normalizedValue : placeholderValue;

  return (
    <select
      className = {classNames(styles.select_input, className)}
      value={safeValue}
      disabled={disabled}
      onChange={onChange}
      style={{ width, height }}
    >
      {showPlaceholder && (
        <option value={placeholderValue} disabled>
          {placeholder}
        </option>
      )}
      {choices.map((choice, index) => (
        <option
          key={`${choice}-${index}`}
          className={classNames(styles.option, {
            [styles.option_disabled]: disabledStates[index],
          })}
          value={choice}
          disabled={disabledStates[index]}
        >
          {labels[index]}
        </option>
      ))}
    </select>
  );
};

export default Select;
